import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntersection } from 'react-use';

const MobileModalContentUnderHeader = ({ children, onIntersectionChange }) => {
  const contentUnderHeaderRef = useRef(null);
  const [isMajorityOfContentVisible, setIsMajorityOfContentVisible] = useState(
    false
  );
  const intersection = useIntersection(contentUnderHeaderRef, {
    threshold: 0.6,
  });

  // FIX: Move setState into useEffect instead of calling during render
  // Calling setState during render causes infinite re-render loops
  useEffect(() => {
    if (
      intersection &&
      isMajorityOfContentVisible !== intersection.isIntersecting
    ) {
      setIsMajorityOfContentVisible(intersection.isIntersecting);
      onIntersectionChange?.(intersection.isIntersecting);
    }
  }, [intersection, isMajorityOfContentVisible, onIntersectionChange]);

  return <div ref={contentUnderHeaderRef}>{children}</div>;
};

MobileModalContentUnderHeader.propTypes = {
  children: PropTypes.node,
  onIntersectionChange: PropTypes.func,
};

export default MobileModalContentUnderHeader;
